import { render, staticRenderFns } from "./joinUsList.vue?vue&type=template&id=35f33ea6&"
import script from "./joinUsList.vue?vue&type=script&lang=js&"
export * from "./joinUsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports